module.exports = __webpack_public_path__ + "static/media/monetizationR.f9421ed1.svg";